import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function ProductCard({ product }) {
    const [nameSize, setNameSize] = useState(0);
    const [nameLineHeight, setNameLineHeight] = useState(0);

    const [descSize, setDescSize] = useState(0);
    const [descLineHeight, setDescLineHeight] = useState(0);

    const [priceSize, setPriceSize] = useState(0);
    const [priceLineHeight, setPriceLineHeight] = useState(0);

    // const [boxGap, setBoxGap] = useState(0);

    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    const [paddingAll, setPaddingAll] = useState(0);
    const [paddingBottom, setPaddingBottom] = useState(0);

    useEffect(() => {
        setNameSize((zoomSize/100)*14);
        setNameLineHeight((zoomSize/100)*26);

        setDescSize((zoomSize/100)*12);
        setDescLineHeight((zoomSize/100)*24);

        setPriceSize((zoomSize/100)*16);
        setPriceLineHeight((zoomSize/100)*28);
        // setBoxGap((zoomSize/100)*10);

        setPaddingAll((zoomSize/100)*8);
        setPaddingBottom((zoomSize/100)*16);
    }, [zoomSize]);

    return (
        <div className="flex flex-col rounded-3xl overflow-hidden bg-[#FFFFFF78] border border-[#E2E2E2] h-fit">
            <div className="w-full aspect-square rounded-3xl overflow-hidden">
                <img className='size-full object-cover' src={product?.productImgUrls[0]} alt={product.productName} />
            </div>

            <div style={{ paddingLeft: `${paddingAll}px`, paddingRight: `${paddingAll}px`, paddingTop: `${paddingAll}px`, paddingBottom: `${paddingBottom}px` }} className="flex flex-col">
                <div className='flex items-center gap-1'>
                    <p style={{ fontSize: `${priceSize}px`, lineHeight: `${priceLineHeight}px` }} className='font-medium text-[#212121]'>₹{product.productSellingPrice}</p>

                    {
                        product.productMRP > product.productSellingPrice && 
                        <>
                            <p style={{ fontSize: `${nameSize}px`, lineHeight: `${nameLineHeight}px` }} className='font-normal text-[#7A869A] line-through'>₹{product.productMRP}</p>

                            <p style={{ fontSize: `${descSize}px`, lineHeight: `${descLineHeight}px` }} className='font-semibold text-[#50B42F]'>{Math.round(((product.productMRP - product?.productSellingPrice) / product.productMRP) * 100).toFixed(0)}% off</p>
                        </>
                    }
                </div>

                <p style={{ fontSize: `${nameSize}px`, lineHeight: `${nameLineHeight}px` }} className='font-bold text-[#212121] line-clamp-1'>{product.productName}</p>

                <p style={{ fontSize: `${descSize}px`, lineHeight: `${descLineHeight}px` }} className='line-clamp-1 font-medium text-[#7A869A]'>{product.productDesc}</p>
            </div>
        </div>
    )
}

export default ProductCard;
